<template>
  <div id="app">
    <dingbu v-if="this.$route.path!='/show'"></dingbu>
    <router-view style="min-height: calc(100vh - 332px);" />
    <foot v-if="this.$route.path!='/show'"></foot>
  </div>
</template>
<script>
import dingbu from './views/dingbu/index.vue'
import foot from './views/foot/foot.vue'
export default {
  components: {
    foot,
    dingbu
  },
}
</script>
<style lang="scss">

// ::-webkit-scrollbar {
//   width: 0 !important;
//   height: 0;
// }
/* else broswer */
::-webkit-scrollbar {
  /* 滚动条整体样式 */
  width: 7px;
  /* 高宽分别对应横竖滚动条的尺寸 */
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.5);
  border: 0;
}
[litewebchat-theme="dark"] ::-webkit-scrollbar-thumb {
  background-color: rgba(84, 91, 95, 0.5);
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: #fff;
  min-height: 50%;
  min-height: 20px;
}
[litewebchat-theme="dark"] ::-webkit-scrollbar-track {
  background: rgb(24, 26, 27);
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}
* {
  padding: 0;
  margin: 0;
  font-family: "microsoft yahei";
}
#app{
  min-height: 100vh;
}
li {
  list-style: none;
}

a {
  text-decoration: none;
}
</style>
<style lang="scss">
.dialog-footer>button[data-v-97d4705e] {
  font-size: 14px !important;
}

th div {
  color: #333 !important;
}

body {
  background-color: #f8f8f8;
}

.el-button--primary {
  background-color: #0958d9;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0958d9;
}

.kaohetitle {
  width: 100%;
  display: block;
  box-sizing: border-box;
  padding: 20px;
  color: #0958d9;
  font-size: 20px;
  margin-left: 20px;
  margin-bottom: 30px;
  border-left: 3px solid #0958d9;
}

.left_box {
  width: 220px;
  margin-right: 20px;
  box-sizing: border-box;
  min-height: 0vh !important;

  >.nav_smallbox {
    width: 100%;
    height: auto !important;
    min-height: 0vh !important;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 20px;
    max-height: none !important;

    >.guanli_title {
      width: 100%;
      font-size: 24px;
      font-weight: 500;
      padding-bottom: 15px;
      border-bottom: 1px solid #999;
    }

    >.navList {
      width: 1005;
      display: flex;
      flex-direction: column;
      margin-top: 30px;

      >li {
        margin: 20px 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        >i {
          margin-right: 10px;
        }
      }
    }
  }

}
</style>
<style lang="scss">
.experimentSearch {
  input {
    color: #999;
  }
}

.experimentSearch>button {
  margin-right: -3px !important;
  margin-bottom: 2px;
  background-image: none !important;

  i {
    color: #5A5A5A !important;
    font-size: 16px;
  }
}

.inp {
  position: relative;

  >input {
    display: flex;
    align-items: center;
    width: 196px;
    height: 36px;
    background-color: #f2f2f2;
    border-radius: 24px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 15px;
    outline: none;
    border: none;
    border-radius: 18px !important;
    padding-left: 10px;
    // background-color: #DCE3FF;
    color: #6b6f83;
    background-color: #F2F2F2;
    border-radius: 18px;
    color: #999;

  }

  >i {
    color: #5A5A5A !important;
    margin-top: 2px;
  }

  // >input::placeholder {}

  >i {
    font-size: 15px;
    color: #b6bedb;
    position: absolute;
    right: 10px;
    top: 8px;
  }
}


.btn_submit {
  width: 120px;
  height: 36px;
  // background: #0958d9;
  background-color: #F2F2F2;
  color: #333;
  border-radius: 18px;
  border: none;
  outline: none;
  position: absolute;
  cursor: pointer;
  right: 0px;
  margin-right: 20px;
  width: 120px;
  height: 36px;
  outline: none;
  border: none;
  color: #333;
  cursor: pointer;
  border-radius: 5px;
  // padding-left: 40px;
  padding-right: 10px;
  background-color: #F2F2F2;
  border-radius: 24px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  // background-image: url(../../assets/添加.png);
  background-size: 15%;
  background-repeat: no-repeat;
  background-position: 22px center;
  cursor: pointer;
  margin-right: 20px;

  >i {
    color: #0958d9;
    margin-right: 10px;
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.kaoshi .el-dialog__title {
  font-family: MicrosoftYaHei-Bold !important;
  font-size: 20px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  letter-spacing: 0px !important;
  color: #333333 !important;
  border-left: 4px solid #0958d9 !important;
  padding-left: 10px !important;
}

.kaoshi1 .el-dialog__title {
  font-family: MicrosoftYaHei-Bold !important;
  font-size: 20px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  letter-spacing: 0px !important;
  color: #333333 !important;
  border-left: 4px solid #0958d9 !important;
  padding-left: 10px !important;
}
</style>